import { IBaseStore } from '../types'
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import Api from '../../api'
import { ITransactionEffectiveDateComment } from '@zunta/configurations'

const groupBy = require('lodash.groupby')

export type ITCommentWithReply = ITransactionEffectiveDateComment & { reply: ITransactionEffectiveDateComment[] }

export interface IClaimState {
  comments: ITCommentWithReply[];
}

export interface IClaimStore extends IBaseStore {
  state: IClaimState
}

@Module({
  name: 'claim',
  namespaced: true
})
export class ClaimModule extends VuexModule {
  comments: ITCommentWithReply[] = [];

  @Mutation
  SET_COMMENTS (comments: ITransactionEffectiveDateComment[]) {
    this.comments = []
    const grouped = groupBy(comments, 'baseComment')
    for (let i = 0; i < comments.length; i++) {
      const comment = comments[i]
      
      if (comment.baseComment) continue

      const commentWithReply = {
        ...comment,
        reply: grouped[comment.id] || []
      }
      this.comments.push(commentWithReply)
    }
  }

  @Action
  async fetchTransactionComments (tedId: number | string) {
    const comments = await Api.claimFlow.getTransactionComments(tedId)
    this.SET_COMMENTS(comments)
  }

  @Action
  async addTransactionComment (input: { claimTaskId: number | string, baseComment: number | null, text: string }) {
    await Api.claimFlow.addComment(input.claimTaskId, input.text, input.baseComment)
  }
}
